module.exports = __webpack_public_path__ + "assets/img/yutou_519_4.d9e765b4.jpg";